import React from "react";

const Cricket = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      className={className}
    >
      <g clip-path="url(#clip0_14545_80158)">
        <path d="M8.26443 18.7197L3.60037 23.3828C2.77768 24.2054 1.43963 24.2054 0.616968 23.3828C-0.20569 22.5602 -0.205622 21.2221 0.616968 20.3994L5.28005 15.7353L8.26443 18.7197ZM16.7869 16.793C18.357 15.2227 21.0156 15.1105 22.7263 16.8213C24.4651 18.5601 24.3471 21.1683 22.7547 22.7607C21.1054 24.4096 18.4353 24.4093 16.7869 22.7607C15.1502 21.1241 15.151 18.429 16.7869 16.793ZM12.74 17.2275L12.2429 17.7246C12.1351 17.8322 11.9959 17.9024 11.8455 17.9238L9.75662 18.2217L5.7781 14.2441L6.07693 12.1543C6.09825 12.004 6.16762 11.8644 6.27517 11.7568L6.77224 11.2598L12.74 17.2275ZM14.7293 15.2383L13.7342 16.2324L7.76736 10.2646L8.7615 9.27051L14.7293 15.2383ZM17.4646 0.567381C18.6971 -0.665283 21.192 0.315307 22.4383 1.56152C23.6845 2.80775 24.6651 5.30269 23.4324 6.53515L15.7234 14.2432L9.75662 8.27539L17.4646 0.567381Z" />
      </g>
    </svg>
  );
};

export default Cricket;
